import React, { useEffect, useContext, useState } from "react"
import RightSideBar from "../section-right-side-bar"
import { applyComma, lineCapital } from "../../../shared/functions"
import { generateBI } from "../../../services/apiservice"
import { JourneyContext } from "../../context/journeyContext"
import { PageContext } from "../../context/pageContext"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { DataLayerEventContext } from "../../context/dataLayerEventContext"
import { getValueFromLookup, DataLayerIntegration } from "../../services/helperFunctions"
import * as lookup from "../../../../static/lookup.json"
export default function YourPremiumQuotationGSP(props){
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [dataLayerEventState, setDataLayerEventState] = useContext(DataLayerEventContext)

  const handlePrevious = () => {
    let sectionIndex = props.currentSectionIndex
    let pageIndex = props.currentPageIndex
    let sectionIndexToEmpty = sectionIndex - 1
    let pageSectionIndexToEmpty =`${pageIndex}${sectionIndexToEmpty}`
    let eventCalledToFillObject = {}
    let eventCalledToFill = Object.keys(
      dataLayerEventState?.eventCalled
    ).filter(element => {
      return element !== pageSectionIndexToEmpty
    })
    console.log(eventCalledToFill);
    for(let i=0; i<eventCalledToFill.length;i++){
      eventCalledToFillObject[eventCalledToFill[i]] = true
    }
    console.log(eventCalledToFillObject);
    setDataLayerEventState(prev=>{
      return{
        eventCalled:{
          ...eventCalledToFillObject
        }
      }
    })
    console.log(dataLayerEventState);
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "previous", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    pageState.pageData.map((element, index) => {
      if (
        element.sectionId ===
        props.sections[props.currentSectionIndex - 1].sectionId // setting section context from page context
      ) {
        setSectionState(prev => {
          return {
            ...prev,
            sectionId: element.sectionId,
            sectionData: element.sectionData,
          }
        })
      }
    })
    props.setCurrentSectionIndex(prev => prev -1)
  }

  const handleProceed = () => {
    let journeyFormatData = props.applicationDataInJourneyFormat()
    DataLayerIntegration(journeyFormatData, "proceed", props.sections?.[props.currentSectionIndex]?.sectionId, "", journeyState)
    props.setCurrentPageIndex(prev => prev + 1)
    props.setCurrentSectionIndex(0)
  }

  useEffect(async () => {
    console.log("journeyState", journeyState.gurantedSavingsBiKeys)
    if (!journeyState.gurantedSavingsBiKeys.premiumAmount) {
      let payload = {
        journeyId: journeyState.journeyId,
      }
      const biApiData = await generateBI(payload)
      if (biApiData.data?.BIJson) {
        let biJson = JSON.parse(biApiData.data?.BIJson)
        let premiumAmount = Math.floor(biJson[0]?.["MODAL_PREM"])
        let expectedBonusAmount = Math.round(biJson[biJson.length -1]?.["ACCRUED_GUAR_ADDITIONS"] + biJson[biJson.length -1]?.["SURVIVAL_BENEFIT"])
        let gurantedSumAssured = Math.round(biJson[0]?.["SUM_ASSURED_MATURITY"])
        let total = expectedBonusAmount + gurantedSumAssured
        let maturityBenefit = Math.round(biJson?.[biJson[0]?.POLICYTERM -1]?.MATURITY_BENEFIT)
        setJourneyState(prev => {
          return {
            ...prev,
            gurantedSavingsBiKeys: {
              premiumAmount: premiumAmount,
              gurantedSumAssured: gurantedSumAssured,
              expectedBonusAmount: expectedBonusAmount,
              total: total,
              maturityBenefit: maturityBenefit,
              biJson: biJson
            },
          }
        })
      }
    }
  }, [])

  return (
    <>
      <style>
        {`
        .disclosures ul li{
          padding-bottom:15px;
        }
          .mg-ckyc-top.desktop-view-right-side {
            margin-top: 39px;
          }
          button.select2-selection__clear {
            display: none;
          }
          .guranteedSumAssurdBox{
            width:100%;
            position:relative;
            left:15px;
          }
        
          .form-group {
            position: relative;
          }
        
          .text-danger {
            color: #a94442;
            position: absolute;
            left: 0;
            bottom: -20px;
          }
        
          #swords {
            position: absolute;
            z-index: 2;
            right: 38px !important;
            top: 0px;
          }
        
          #sumAssured-error {
            position: absolute;
            bottom: -3px;
            z-index: 2;
          }
        
          button.select2-selection__clear {
            display: none;
          }
        
          .sumassuredselect select#nonfilterselect {
            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url("images/arrow-sm.png");
            background-repeat: no-repeat;
            background-position-x: 99%;
            background-position-y: 17px;
          }
        
          #words {
            position: absolute;
            right: 58px;
            top: 27px;
          }
        
          select::-ms-expand {
            display: none;
          }
        
          .sumassuredselect {
            position: relative;
            height: 45px;
            width: 100%;
          }
        
          .sumassuredselect input.form-control {
            position: absolute;
            z-index: 2;
            width: calc(100% - 35px);
            left: 3px;
            height: 42px;
            top: 0;
            box-shadow: none;
            border: 0;
            display: block !important;
            background: #ededed;
            border-right-color: transparent;
          }
        
          .sumassuredselect select#nonfilterselect {
            position: absolute;
            top: 0;
            width: 100%;
            left: 0;
            right: 0;
            background: #ededed;
            z-index: 1;
            text-align: center;
            border-left-color: transparent;
          }
          .or-jeevan {
            position: relative;
          }
        
          @media (min-width: 1024px) and (max-width: 1366px) {
            .top_space {
              margin-top: 11vh;
            }
          }
          .result-design {
            background-color: ${props =>
              props.channel === "A"
                ? "#3e505d"
                : props.channel === "B"
                ? "#a20a3a"
                : props.channel === "C"
                ? "#0ab0ef"
                : "#eb7f25"};
            background-color: var(--lumiq-card-bg);
            padding: 20px;
            margin-bottom: 30px;
            float: left;
            width: 100%;
          }
          .total-premium-jeevan-design{
            color: #fff;
            text-align: center;
            padding-bottom: 20px;
            border-bottom: 1px solid #fff;
          }
          .totalpr-jeevan {
            display: inline-block;
            font-size: 25px;
          }
          .price-jeevan {
            display: inline-block;
            font-size: 25px;
            text-decoration: underline;
            margin-left: 20px;
          }
          .total-premium-jeevan-design p {
            margin-top: 7px;
          }
          .total-meturity-jeevan {
            text-align: center;
            color: #fff;
            padding: 35px 0px;
            padding-top: 25px;
          }
          .total-meturity-jeevan h2 {
            background-color: ${props =>
              props.channel === "A"
                ? "#3e505d"
                : props.channel === "B"
                ? "#a20a3a"
                : props.channel === "C"
                ? "#0ab0ef"
                : "#eb7f25"};
            background-color: var(--lumiq-card-bg);
            padding: 4px;
            z-index: 2;
            position: relative;
            width: 340px;
            margin: auto;
            font-size: 25px;
          }
          .line-jeev {
            width: 430px;
            height: 2px;
            background-color: #fff;
            margin: auto;
            margin-top: -15px;
            z-index: 1;
            position: relative;
          }
          .wd-total-metrurity {
            width: 45.666667%;
          }
          .jeevan-neeves-premium {
            border: 1px solid #fff;
            padding: 17px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
          }
          .listing-total {
            float: left;
            width: 100%;
          }
          .price-jeevan-toal {
            list-style: none;
            color: #fff;
            padding: 0px;
            font-size: 14px;
          }
          .price-jeevan-toal li {
            display: inline-block;
            margin-right: 5px;
          }
          .text-rt-jeevan {
            text-align: right;
            margin-right: 0px !important;
            float: right;
          }
          .total-mrp-jeevan {
            border-top: 1px solid #fff;
            padding-top: 10px;
            font-size: 23px;
            text-align: right;
            color: #fff;
            font-weight: bold;
          }
          .percnt-jeevan {
            float: right;
            background-color: #fff;
            padding: 35px 7px;
            color: #0bb0f0;
            font-size: 23px;
            height: 100px;
            font-weight: bold;
          }
          .or-jeevan {
            position: relative;
          }
          .or-jeevan {
            text-align: center;
            width: 1px;
            height: 150px;
            background-color: #fff;
            margin: auto;
          }
          .or-jeevan p {
            color: #fff;
            font-size: 20px;
            text-transform: uppercase;
            margin: 50px 10px;
            margin-left: -17px;
            background-color: #0bb0f0;
            position: absolute;
          }
         
          @media (max-width: 991px) and (min-width: 768px){
            .guranteedSumAssurdBox{
              padding: 0px 15px 15px 15px;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 0px;
              padding-top:10px;
            }
            .line-jeev {
              width: 70%;
            }
            .wd-total-metrurity {
              width: 100%;
            }
            .jeevan-neeves-premium {
                margin-bottom: 10px;
                padding: 10px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            } 
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              width: 45px;
              left: 0px;
              right: 0px;
              margin: auto;
              top: 16px;
            }
          }
          
          @media (max-width: 767px){
            .result-design {
                padding: 12px;
                padding-bottom: 0px;
            }
            .pl-pr {
              padding: 0px;
            }
            .wd-total-metrurity {
              width: 100%;
            }
            .total-premium-jeevan-design {
              padding-bottom: 7px;
            }
            .total-meturity-jeevan {
              margin-bottom: 0px;
              padding-top: 10px;
              padding-bottom: 20px;
            }
            .total-meturity-jeevan h2 {
              font-size: 20px;
              width: 300px;
              display: inline-block;
              margin-top: 15px;
            }
            .line-jeev {
              width: 94%;
              display:none;
            }
            .jeevan-neeves-premium {
              
              padding: 10px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .price-jeevan-toal li {
              font-size: 12px;
            }
            .total-mrp-jeevan {
              font-size: 20px;
              padding-top: 5px;
            }
            .percnt-jeevan {
              width: 100%;
              text-align: center;
              height: 40px;
              padding: 0px;
            }
            .or-jeevan {
              width: 100%;
              height: 1px;
              margin: 30px 0px;
            }
            .or-jeevan p {
              top: -14px;
            }
            .listing-total {
              width: 100%;
              margin-bottom: 10px;
            }
            .price-jeevan-toal {
              margin-bottom: 5px;
            }
            .form-group span#plan_option-error {
              top: 49px;
            }
            .form-group span#policy_term-error {
              top: 51px;
            }
            .form-group span#payment_term-error {
              top: 50px;
            }
            .form-group span#payment_frequency-error {
              top: 51px;
            }
            .or-jeevan p{
              top: -14px;
            }
            .guranteedSumAssurdBox{
              width: 95%;
              left: 30px;
            }
          
          }
          
          @media (min-width: 768px) and (max-width: 991px){
            .pl-pr {
                padding: 0px;
              }
              .total-meturity-jeevan h2 {
                  font-size: 20px;
                  width: 300px;
                  display: inline-block;
                  margin-top: 15px;
              }
              .disclosures ul li{
                padding-bottom:10px;
                line-height:1rem;
                font-size:0.8rem;
              }
            
            }
          
            @media (max-width: 767px) and (min-width: 360px){
                .totalpr-jeevan {
                    font-size: 1.2rem;
                  }
                .price-jeevan{
                    font-size: 1.2rem;
                  }
                  .thePremiumShow{
                    font-size: .8rem !important;
                  }
                .total-meturity-jeevan h2 {
                  font-size: 1.2rem;
                  width: 300px !important;
                  display: inline-block;
                  margin-top: 15px;
                }
                .result-design {
                  padding: 20px;
                }
                .jeevan-neeves-premium{
                  margin-bottom:10px;
                }
                .guranteedSumAssurdBox {
                  width: 100%;
                  left: 13px;
                }
                .iselect-heading{
                  padding-top:10px;
                  margin-bottom: -10px;
                }
                .disclosures{
                  font-size:0.8rem;
                }
                .disclosures ul li{
                  padding-bottom:20px;
                }
                
            }
        `}
      </style>
      <div className="container">
        <div className="row ps-4 pe-4">
          <div className="col-lg-9 pl-pr brd-right mt-20">
            <div className="row">
              <div className="col-lg-12 pl-pr">
                <div className="iselect-box-design mg-bottom-10 new-iselect-box">
                  <div className="heading-design">
                    <div className="iselect-padding left-side-head">
                      <h1 className="iselect-heading">
                        Your Premium Quotation
                      </h1>
                    </div>
                    <div class="app-quatation mt hidden-desktop-screen">
                      <div class="application-design-number">Application Number: {journeyState.applicationNo}</div>
                    </div>
                  </div>
                  <div class="iselect-padding">
                    <div class="result-design">
                      <div class="row">
                        <div class="col-lg-12 pl-pr">
                          <div class="total-premium-jeevan-design">
                            <div class="totalpr-jeevan">Premium:</div>
                            <div
                              class="price-jeevan"
                              style={{
                                textDecoration: "none",
                                "margin-left": "2px",
                              }}
                            >
                              <span class="fa fa-rupee"></span>
                              <strong> {applyComma(journeyState.gurantedSavingsBiKeys.premiumAmount) } </strong>
                              <small style={{ "fontSize": "16px" }}> {getValueFromLookup("premiumFrequency", journeyState.paymentFrequency).toLowerCase()}</small>
                            </div>
                            <p
                              style={{ fontStyle: "italic" }}
                              className="thePremiumShow"
                            >
                              The premium shown above is exclusive of taxes.
                            </p>
                          </div>
                          <div class="row">
                            <div class="col-lg-12">
                              <div class="total-meturity-jeevan">
                                <h2> Guaranteed Maturity Benefit</h2>
                                <div class="line-jeev"></div>
                              </div>
                            </div>
                          </div>
                          <div class="row guranteedSumAssurdBox">
                            <div class="col-lg-12 pl pl-pr  ">
                              <div class="jeevan-neeves-premium">
                                <div class="listing-total">
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Sum Assured</li>
                                    <li class="text-rt-jeevan">
                                      {" "}
                                      <span class="fa fa-rupee"></span>
                                      {applyComma(
                                        journeyState.gurantedSavingsBiKeys
                                          .gurantedSumAssured
                                      )}
                                    </li>
                                  </ul>
                                  <ul class="price-jeevan-toal">
                                    <li>Guaranteed Additions</li>
                                    <li class="text-rt-jeevan">
                                      {" "}
                                      <span class="fa fa-rupee"></span>
                                      {applyComma(
                                        journeyState.gurantedSavingsBiKeys
                                          .expectedBonusAmount
                                      )}
                                    </li>
                                  </ul>
                                  <div class="total-mrp-jeevan">
                                    {" "}
                                    <span class="fa fa-rupee"></span>{" "}
                                    {applyComma(
                                      journeyState.gurantedSavingsBiKeys.total
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clearfix"></div>
                  <div class="hidden-desktop-screen">
                    <div class="iselect-mg-bottom mt-30">
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="but-center text-center">
                            <div
                              class="submit-btn cen"
                              aria-hidden="true"
                              onClick={handlePrevious}
                            >
                              {" "}
                              <a>Previous</a>{" "}
                            </div>
                            <input
                            aria-hidden="true"
                              onClick={handleProceed}
                              class="previous-btn cen inline-btn-wd"
                              style={{
                                color: "white",
                                border: "none",
                                padding: "14px 40px",
                              }}
                              type="button"
                              value="View BI to Proceed"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <RightSideBar
            sections={props.sections}
            currentSectionIndex={props.currentSectionIndex}
            setCurrentSectionIndex={props.setCurrentSectionIndex}     
            showMainButtonFlexiEdgePlan={props.showMainButtonFlexiEdgePlan}
            setShowMainButtonFlexiEdgePlan={props.setShowMainButtonFlexiEdgePlan}   
            channelForColorChange = {journeyState.channel}     
          />
        </div>

        <div>
          <div className="discloser iselect-box-design">
          <h2>Important Notes: </h2>
          <ul>
          <li>Guaranteed Maturity Benefit = Guaranteed Sum Assured on Maturity + Cumulative Guaranteed Yearly Additions + Guaranteed Loyalty Addition </li>
          <li>
              <ol type="a">
                    <li>Guaranteed Savings Option: The Death Benefit is the benefit payable on death of the Life Assured, which is Sum Assured on Death plus Guaranteed Yearly Additions accrued till the date of death. Where Sum Assured on Death is defined as Higher of (11 times the Annualized Premium or Guaranteed Sum Assured on Maturity or Absolute amount assured to be paid on death or 105% of the Total Premiums Paid till the date of death), </li>
                    <li>Guaranteed Savings with Double Protection Option: The Death Benefit is the benefit payable on death of the Life Assured, which is Sum Assured on Death plus Guaranteed Yearly Additions accrued till the date of death. If death of the Life Assured is due to an accident, an additional amount equal to the ADB Sum Assured will be paid to the Nominee. Where Sum Assured on Death is defined as Higher of (11 times the Annualized Premium or Guaranteed Sum Assured on Maturity or Absolute amount assured to be paid on death or 105% of the Total Premiums Paid till the date of death), </li>
                    <li> Guaranteed Savings with Premium Protection Option: The Death Benefit is the benefit payable on death of the Life Assured, which is Sum Assured ion Death. In addition, future premiums are not payable and on maturity, Guaranteed Sum Assured on Maturity plus Accrued Guaranteed Yearly Additions and Guaranteed Loyalty Addition, will be payable. Where Sum Assured on Death is defined as Higher of (11 times the Annualized Premium or Guaranteed Sum Assured on Maturity or Absolute amount assured to be paid on death or 105% of the Total Premiums Paid till the date of death) </li>

              </ol>
          </li>

          <li> Minimum Guaranteed Surrender Value / Special Surrender Value is payable at the end of the policy year.</li>
          <li>Annualized premium mentioned excludes rider premiums, underwriting extra premium and loadings for modal premiums, if any, as well as excludes Goods and Services Tax & applicable cess (es)/other levy, if any. </li>
          <li>Instalment premium mentioned above is inclusive of underwriting extra premium & loadings for modal premium, if any. </li>
          <li>A Policy shall acquire lapse status if the Policyholder fails to pay due premium within the Grace Period in the first 2 consecutive Policy years. In such case your Policy will lapse at the expiry of the grace period and the insurance cover will cease immediately. No benefit shall be payable upon death or upon your request for termination of the Policy or on the expiry of the revival period.</li>
          <li>Guaranteed Yearly Additions will be calculated as a percentage of cumulative Annualized Premium(s) paid and vary by the Premium Payment Term. Guaranteed Yearly Additions will accrue at the end of each Policy Year throughout the Premium Payment Term, provided all premiums due till the end of that Policy Year have been paid. </li>

        </ul>
          </div>
          <div className="discloser iselect-box-design" style={{marginTop:"0px",paddingTop:"0px"}}>
              <h2>Other points to note: </h2>
              <ul>
                <li>Guaranteed Yearly Addition (s) and Guaranteed Loyalty Addition will be payable provided all due premiums are paid and Policy is in-force.</li>
                <li>This is a traditional plan intended for long term savings and benefits. It is strongly advised that the Policy should be continued
                 throughout the defined Policy term to realize the full benefits. Early exit should not be opted for unless there is no other alternative 
                 available, as it will impact the Policy value. If premiums are discontinued after payment of at least first consecutive Policy 
                 yearsÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ premiums then the Policy will acquire a Paid-up value. You will receive this Paid-up value on death or on maturity,
                  provided you have not surrendered or revived the Policy. </li>
                <li>Your policy will acquire a guaranteed surrender value (GSV) after payment of at least first 2 consecutive policy years
                ÃƒÂ¢Ã¢â€šÂ¬Ã¢â€žÂ¢ premiums. However, the Company may offer a special surrender value (SSV), and higher of 
                GSV or SSV will be paid on surrender. The Illustration shows both the GSV as well as the current SSV payable on 
                surrender of the policy. SSV scales may be revised in the future by the Company with the prior approval of the Authority. </li>
                <li>You may be entitled for tax benefits under Section 80C and Section 10(10D), as per the Income Tax Act, 1961 as amended from time to time. </li>
                <li>The premium shown is for a healthy individual. Your application will be assessed as per Board approved underwriting Policy of the Company. 
                Basis underwriting, it may result in extra premium to be paid, which shall be borne by you. </li>
                <li>For more details on product features and terms and conditions please read sales brochure or sample Policy contract carefully before concluding a sale. </li>
              </ul>
          </div>
          <div className="discloser iselect-box-design" style={{marginTop:"0px",paddingTop:"0px"}}>
              <h2>Disclosures:</h2>
              <ul>
                <li style={{listStyleType:"none"}}>Corporate Agent will receive commission basis the premium payment term (PPT) of the policy from the company for this transaction:-
                {conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsChooseGuranteedSum.GSPPremiumPolicyTerm"] === "10" ? "10 years PPT :- 30%": conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsChooseGuranteedSum.GSPPremiumPolicyTerm"] === "7" ? "7 years PPT :- 21%":conditionState["PageGuaranteedSavingsCalculatePremium.SectionGuaranteedSavingsChooseGuranteedSum.GSPPremiumPolicyTerm"] === "5"? "5 years PPT :- 15%": ""} commission on 1st year premium, 5% from 2nd year onwards. IRDA regulations do not permit Corporate Agent or its 
                employees to pay such commission, whether in part or whole, as an inducement to any person to take out or renew or continue an insurance policy of any kind. </li>
              </ul>
              <p></p>
          </div>
        </div>
      </div>

      {/* Mobile view Buttons */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure">
        <div className="iselect-mg-bottom">
          <div className="row">
            <div className="col-lg-12">
              <div className="but-center text-center">
                <div
                  className="submit-btn cen"
                  style={{ paddingLeft: "5px" }}
                  aria-hidden="true"
                  onClick={handlePrevious}
                >
                  {" "}
                  <a>Previous </a>{" "}
                </div>
                <input
                aria-hidden="true"
                  onClick={handleProceed}
                  className="previous-btn cen bi-btv"
                  style={{
                    color: "white",
                    padding: "14px 0px",
                    border: "none",
                    marginLeft: "10px",
                    width: "160px",
                  }}
                  type="button"
                  form="aDetail"
                  align="right"
                  value="View BI to Proceed"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
